var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronLeft16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.46 3.46a.65.65 0 10-.92-.92l.92.92zM5 8l-.46-.46a.65.65 0 000 .92L5 8zm4.54 5.46a.65.65 0 10.92-.92l-.92.92zm0-10.92l-5 5 .92.92 5-5-.92-.92zm-5 5.92l5 5 .92-.92-5-5-.92.92z",
    fill: "#495057"
  })));
}

export default SvgChevronLeft16;